var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49967 9.33325C2.86786 9.33325 3.16634 9.63173 3.16634 9.99992V12.6666C3.16634 12.8434 3.23658 13.013 3.3616 13.138C3.48663 13.263 3.6562 13.3333 3.83301 13.3333H13.1663C13.3432 13.3333 13.5127 13.263 13.6377 13.138C13.7628 13.013 13.833 12.8434 13.833 12.6666V9.99992C13.833 9.63173 14.1315 9.33325 14.4997 9.33325C14.8679 9.33325 15.1663 9.63173 15.1663 9.99992V12.6666C15.1663 13.197 14.9556 13.7057 14.5806 14.0808C14.2055 14.4559 13.6968 14.6666 13.1663 14.6666H3.83301C3.30257 14.6666 2.79387 14.4559 2.41879 14.0808C2.04372 13.7057 1.83301 13.197 1.83301 12.6666V9.99992C1.83301 9.63173 2.13148 9.33325 2.49967 9.33325Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69526 6.19526C4.95561 5.93491 5.37772 5.93491 5.63807 6.19526L8.5 9.05719L11.3619 6.19526C11.6223 5.93491 12.0444 5.93491 12.3047 6.19526C12.5651 6.45561 12.5651 6.87772 12.3047 7.13807L8.9714 10.4714C8.71106 10.7318 8.28894 10.7318 8.0286 10.4714L4.69526 7.13807C4.43491 6.87772 4.43491 6.45561 4.69526 6.19526Z",
    fill: "#16192C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49967 1.33325C8.86786 1.33325 9.16634 1.63173 9.16634 1.99992V9.99992C9.16634 10.3681 8.86786 10.6666 8.49967 10.6666C8.13148 10.6666 7.83301 10.3681 7.83301 9.99992V1.99992C7.83301 1.63173 8.13148 1.33325 8.49967 1.33325Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.61677b1430ae33675a28673652ee4958.svg";
export { ForwardRef as ReactComponent };